export const PUBLIC_ROUTES = {
    LOGIN: '/login',
    REGISTER: '/register',
    SET_PASSWORD: '/set-password',
    RESET_PASSWORD: '/reset-password',
    REQUEST_RESET: '/request/reset',
    TWO_FA: '/2fa',
    INVOICES_PDF_VIEW: '/pdf/:id/:tin',
    INVOICES_PRINT: '/invoices/print/:id',
} as const;

export const PRIVATE_ROUTES = {
    PROFILE: '/profile',
    CHANGE_PASSWORD: '/profile/change-password',
    DASHBOARD: '/dashboard',
    OFFICER_SUMMARY: '/officer-summary',
    TAXPAYERS: '/taxpayers',
    TAXPAYER_DETAILS: '/taxpayers/:tin',
    TAXPAYER_DETAILS_CONTRACTORS: '/taxpayers/:tin/contractors',
    TAXPAYER_DETAILS_INVOICES: '/taxpayers/:tin/invoices',
    TAXPAYER_DETAILS_ACCOUNT: '/taxpayers/:tin/account',
    TAXPAYER_DETAILS_DECLARATION: '/taxpayers/:tin/declaration',
    TAXPAYER_DETAILS_VIOLATIONS: '/taxpayers/:tin/violations',
    TAXPAYER_DETAILS_NOTIFICATIONS: '/taxpayers/:tin/notifications',
    RELATIONS: '/relations',
    INVOICES: '/invoices',
    INVOICES_INCOMING: '/invoices/incoming',
    INVOICES_OUTGOING: '/invoices/outgoing',
    DOCUMENTS_CREATE_INVOICE_ID: '/invoices/create/:invoiceId',
    INVOICE_DETAILS: '/invoices/:id',
    COUNTERPARTIES: '/counterparties',
    COUNTERPARTY_SELLERS: '/counterparties/sellers',
    COUNTERPARTY_BUYERS: '/counterparties/buyers',
    COUNTERPARTY_INCOMING: '/counterparties/:id/incoming',
    COUNTERPARTY_OUTGOING: '/counterparties/:id/outgoing',
    SUBSCRIPTIONS: '/subscriptions',
    EMPLOYERS_CONTROL: '/employers-control',
    AUDIT: '/audit',
    AUDIT_STATISTICS: '/audit/statistics',
    AUDIT_VIOLATIONS: '/audit/violations',
    AUDIT_VIOLATION_DETAILS: '/audit/violations/:id',
    AUDIT_VIOLATION_GENERAL_INFORMATION: '/audit/violations/:id/general-information',
    AUDIT_VIOLATION_NOTIFICATIONS: '/audit/violations/:id/notifications',
    AUDIT_VIOLATION_HISTORY: '/audit/violations/:id/history',
    AUDIT_VIOLATIONS_TAXPAYER_DETAILS: '/audit/violations/taxpayers/:tin',
    AUDIT_JOBS: '/audit/jobs',
    PREFERENCES: '/preferences',
    PREFERENCES_REGISTERS: '/preferences/registers',
    PREFERENCES_DOCUMENT_TEMPLATES: '/preferences/registers/document-templates',
    PREFERENCES_DOCUMENT_TEMPLATE_DETAILS:
        '/preferences/document-templates/:notificationTemplateId',
    PREFERENCES_MESSAGE_TEMPLATE_DETAILS:
        '/preferences/document-templates/:notificationTemplateId/message-templates/:messageTemplateId',
    PREFERENCES_JOB_TEMPLATES: '/preferences/registers/job-templates',
    PREFERENCES_JOB_TEMPLATE_DETAILS: '/preferences/job-templates/:jobTemplateId',
    PREFERENCES_CATALOGS: '/preferences/registers/catalogs',
    PREFERENCES_VIOLATION_THRESHOLDS: '/preferences/registers/catalogs/violation-thresholds',
    PREFERENCES_VIOLATION_TYPES: '/preferences/registers/catalogs/violation-types',
} as const;

export const ROUTES = {
    ...PRIVATE_ROUTES,
    ...PUBLIC_ROUTES,
} as const;
